export default __webpack_public_path__ + "static/media/trash-bin.11567020.svg";